var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('img',{class:{ 'img-mod': _vm.moderation },attrs:{"src":_vm.message.meta.url},on:{"load":function($event){return _vm.$bus.$emit('new-message')},"click":function($event){return _vm.$modal.show('image-modal', { image: _vm.message.meta.url })}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }